import React from 'react';
import { Typography } from '@mui/material';
import SearchBarItem from './SearchBarItem';
import { IUserPaginationResponse } from '../../../interfaces/user.interface';
import { useThemeContext } from '../../../theme/ThemeContextProvider';

type SearchBarListProps = {
  search: string;
  isOpen: boolean;
  isLoading: boolean;
  users?: IUserPaginationResponse;
  onClose: () => void;
};

const SearchBarList = ({
  search,
  isOpen,
  isLoading,
  users,
  onClose,
}: SearchBarListProps) => {
  const { theme } = useThemeContext();

  if (!users) return null;

  return (
    <>
      {users.data.map((user, index) => (
        <SearchBarItem
          user={user}
          onClose={onClose}
          key={`${user.id}-${index}`}
        />
      ))}

      {isOpen && !isLoading && !users?.data.length && search && (
        <Typography
          sx={{
            color: theme.palette.text.secondary,
            width: '100%',
            textAlign: 'center',
            mt: 1,
          }}
        >
          No results found.
        </Typography>
      )}
    </>
  );
};

export default SearchBarList;
